export default import.meta.ROLLUP_FILE_URL_B5xPCdjR;